import * as yup from "yup";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

export default yup.object().shape({
  [fieldTypes.TASK_TYPE]: yup.object()
    .required(translate(null, "care_team_tasks.form.fields.task_type.errors", "required"))
    .nullable(),
  [fieldTypes.TASK_NAME]: yup.string()
    .when(fieldTypes.TASK_TYPE, (taskType, schema) => {
      return taskType && taskType.value === "TASKTYPE_OTHER"
        ? schema.required(translate(null, "care_team_tasks.form.fields.task_name.errors", "required"))
        : schema.nullable();
    }),
  [fieldTypes.CATEGORY]: yup.object()
    .required(translate(null, "care_team_tasks.form.fields.category.errors", "required"))
    .nullable(),
  [fieldTypes.DUE_DATE]: yup.date()
    .required(translate(null, "care_team_tasks.form.fields.due_date.errors", "required"))
    .nullable(),
  [fieldTypes.CONSULT_ID]: yup.object()
    .when(fieldTypes.NOT_CONSULT_RELATED, (notConsultRelated, schema) => {
      return !notConsultRelated
        ? schema.test(
          `${fieldTypes.CONSULT_ID}.value`,
          translate(null, "care_team_tasks.form.fields.consult.errors", "required"),
          ({ value }) => !!value,
        )
        : schema.nullable();
    }),
  [fieldTypes.MEMBER]: yup.object()
    .when(fieldTypes.NOT_CONSULT_RELATED, (notConsultRelated, schema) => {
      return notConsultRelated
        ? schema.test(
          `${fieldTypes.MEMBER}.value`,
          translate(null, "care_team_tasks.form.fields.member.errors", "required"),
          ({ value }) => !!value,
        )
        : schema.nullable();
    }),
});
